import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from './Avatar';
import { useUserStatus } from '../helpers/useUserStatus';
import styles from './UserAvatar.module.css';

export type UserStatus = 'online' | 'meeting' | 'away' | 'offline';

interface UserAvatarProps {
  user: {
    displayName?: string;
    avatarUrl?: string | null;
  };
  /** Explicit status override. Omit or pass 'auto' to use real-time activity detection. */
  status?: UserStatus | 'auto';
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
  showStatus?: boolean;
}

export const UserAvatar = ({
  user,
  status: statusProp,
  size = 'md',
  className = '',
  showStatus = true,
}: UserAvatarProps) => {
  const liveStatus = useUserStatus();
  const status: UserStatus = (!statusProp || statusProp === 'auto') ? liveStatus : statusProp;
  const getInitials = (name?: string) => {
    if (!name) return '??';
    return name
      .split(' ')
      .map((n) => n[0])
      .slice(0, 2)
      .join('')
      .toUpperCase();
  };

  const statusColorClass = styles[status];

  return (
    <div className={`${styles.container} ${styles[size]} ${className}`}>
      <Avatar className={styles.avatar}>
        <AvatarImage
          src={user.avatarUrl
            ? (user.avatarUrl.includes('googleusercontent.com') || user.avatarUrl.includes('lh3.google'))
              ? `/_api/imgproxy?url=${encodeURIComponent(user.avatarUrl)}`
              : user.avatarUrl
            : undefined}
          alt={user.displayName}
        />
        <AvatarFallback>{getInitials(user.displayName)}</AvatarFallback>
      </Avatar>
      {showStatus && (
        <span
          className={`${styles.statusIndicator} ${statusColorClass}`}
          title={`Status: ${status}`}
        />
      )}
    </div>
  );
};
